import styled from 'styled-components';

export const ContaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-width: 0;

  .date {
    font-size: 14px;
  }

  .searchBarContainer {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  .contentHeader {
    p, a {
      font-style: normal;
      line-height: 24px;
    }
  }

  .contentLink {
    display: flex;
    margin-top: 16px;

    svg {
      margin-right: 4px;
    }
  }

  .contentCard {
    display: grid;
    grid-template-columns: 300px 780px 1fr;
    gap: 24px;
    margin-top: 20px;
    min-width: 0;

    max-height: 285px;

    .cards {
      display: flex;
      gap: 24px;
      flex-direction: column;
    }
  }

  @media (max-width: 900px) {
    .contentCard {
      grid-template-columns: minmax(0, 1fr);
      max-height: none;

      .cards {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));
      }
    }
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  /* grid-template-columns: 1fr 30px 1fr 1fr 1fr 1fr; */
  gap: 16px;

  align-items: end;
  min-width: 0;

  > * {
    min-width: 0;
    max-width: 100%;
  }

  .tooltip-custom-div {
    margin: 0;
    padding: 0;
    border: none;
    width: 100%;
    text-align: inherit;
    cursor: text;
  }

  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;

    > * {
      width: 100%;
    }
  }
`;

export const Row = styled.tr`

`;

export const Td = styled.td<{ hasValue?: number }>`
  color: ${({ hasValue }) => hasValue == null ? '' : hasValue >= 0 ? '#2EB033' : '#C11F27'};

  a {
    font-weight: 700;
    color: inherit;
    text-decoration: inherit;
    color: ${({ theme }) => theme.colors.orange.primary};

    transition: filter 0.2s ease-in;

    &:hover {
      filter: brightness(0.8);
    }
  }

  .content-agroup-month {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:nth-child(4n),
  &:nth-child(5n),
  &:nth-child(6n)  {
    font-weight: 700;
  }
`;

export const DownloadContent = styled.a`
  display: flex;

  color: ${({ theme }) => theme.colors.gray[900]};

  font-weight: 600;
  font-size: 14px;
`;
